import { Field, FieldArray, ErrorMessage } from "formik";
import { FilePond } from "react-filepond";
import { getFileNameFromUrl } from "../../../../components/Helper";

interface OtherDocumentsFieldsProps {
  actionType: string;
  values: any;
  documentList: any[];
  filePondDocuments: any;
  setAddDocumentModalStatus: (show: boolean) => void;
  setFilePondDocuments: (files: any) => void;
  handleFileChange: (
    fileItems: any,
    setFieldValue: any,
    inputKey: string
  ) => void;
  setFieldValue: any;
  permissions: any;
}

const OtherDocumentsFields: React.FC<OtherDocumentsFieldsProps> = ({
  actionType,
  values,
  documentList,
  filePondDocuments,
  setAddDocumentModalStatus,
  setFilePondDocuments,
  handleFileChange,
  setFieldValue,
  permissions,
}) => {
  return (
    <div className="card my-card">
      <FieldArray
        key={"other_documents"}
        name="other_documents"
        render={({ push, remove }) => (
          <>
            <div className="card-header my-card-header bg-lighter d-flex justify-content-between">
              <div>
                <h6 className="my-card-header-head">Other Documents</h6>
              </div>
              <div>
                <button
                  title="Add Document"
                  className="btn btn-sm btn-primary waves-effect waves-light p-0"
                  type="button"
                  style={{ margin: "5px" }}
                  onClick={() => {
                    push({ document_id: "", files: [] });
                  }}
                >
                  <span>
                    <i className="ti ti-plus my-card-icon-button"></i>
                  </span>
                </button>
              </div>
            </div>
            {actionType === "create" ? (
              <>
                {values?.other_documents?.map((doc: any, index: number) => (
                  <div
                    key={index}
                    className="card-body my-card-body"
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <div className="sales_section_card" key={index}>
                      <div className="row g-3 m-0">
                        <div className="col-12 col-sm-5 col-md-4">
                          <div className="d-flex justify-content-between">
                            <div>
                              <label
                                htmlFor={`other_documents[${index}].document_id`}
                                className="form-label"
                                style={{ fontSize: "0.9375rem" }}
                              >
                                Documents:{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                            {permissions.includes("create-document") && (
                              <div>
                                <button
                                  title="Add Document"
                                  className="btn btn-sm btn-primary waves-effect waves-light p-0"
                                  type="button"
                                  onClick={() =>
                                    setAddDocumentModalStatus(true)
                                  }
                                >
                                  <span>
                                    <i className="ti ti-plus my-card-icon-button"></i>
                                  </span>
                                </button>
                              </div>
                            )}
                          </div>
                          <Field
                            as="select"
                            name={`other_documents[${index}].document_id`}
                            className="form-select"
                          >
                            <option value="">Select Document</option>
                            {documentList.map((data) => {
                              const isOptionDisabled =
                                values.other_documents.some(
                                  (doc: any, docIndex: number) =>
                                    doc.document_id === data.id &&
                                    docIndex !== index
                                );

                              return (
                                <option
                                  key={data.id}
                                  value={data.id}
                                  disabled={isOptionDisabled}
                                >
                                  {data.name}
                                </option>
                              );
                            })}
                          </Field>
                          <ErrorMessage
                            name={`other_documents[${index}].document_id`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="col-12 col-sm-7 col-md-8">
                          <div className="file-pond-main-block">
                            <FilePond
                              files={filePondDocuments[index]}
                              onupdatefiles={(fileItems) => {
                                const newData = filePondDocuments;
                                newData[index] = fileItems;
                                setFilePondDocuments(newData);
                                handleFileChange(
                                  fileItems,
                                  setFieldValue,
                                  `other_documents[${index}].files`
                                );
                              }}
                              allowMultiple
                              name={`other_documents[${index}].files`}
                              labelIdle="Drag & drop files or click to browse"
                            />
                          </div>
                          <ErrorMessage
                            name={`other_documents[${index}].files`}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <i
                          className="fa-solid fa-xmark sales_document_btn"
                          onClick={() => remove(index)}
                        ></i>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                {values.other_documents.map((doc: any, index: number) => (
                  <div
                    className="card-body my-card-body"
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <div className="sales_section_card" key={index}>
                      <div className="row g-3 m-0">
                        <div className="col-12 col-md-5 col-sm-5">
                          <div>
                            <div className="d-flex justify-content-between">
                              <div>
                                <label
                                  htmlFor={`other_documents[${index}].document_id`}
                                  className="form-label"
                                  style={{ fontSize: "0.9375rem" }}
                                >
                                  Documents:{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              {permissions.includes("create-document") && (
                                <div>
                                  <button
                                    title="Add Document"
                                    className="btn btn-sm btn-primary waves-effect waves-light p-0"
                                    type="button"
                                    onClick={() =>
                                      setAddDocumentModalStatus(true)
                                    }
                                  >
                                    <span>
                                      <i className="ti ti-plus my-card-icon-button"></i>
                                    </span>
                                  </button>
                                </div>
                              )}
                            </div>
                            <Field
                              as="select"
                              name={`other_documents[${index}].document_id`}
                              className="form-select"
                            >
                              <option value="">Select Document</option>
                              {documentList.map((data) => {
                                const isOptionDisabled =
                                  values.other_documents.some(
                                    (doc: any, docIndex: number) =>
                                      doc.document_id === data.id &&
                                      docIndex !== index
                                  );

                                return (
                                  <option
                                    key={data.id}
                                    value={data.id}
                                    disabled={isOptionDisabled}
                                  >
                                    {data.name}
                                  </option>
                                );
                              })}
                            </Field>
                            <ErrorMessage
                              name={`other_documents[${index}].document_id`}
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <div className="mt-3">
                            <div className="file-pond-main-block">
                              <FilePond
                                files={filePondDocuments[index]}
                                onupdatefiles={(fileItems) => {
                                  const newData = filePondDocuments;
                                  newData[index] = fileItems;
                                  setFilePondDocuments(newData);
                                  handleFileChange(
                                    fileItems,
                                    setFieldValue,
                                    `other_documents[${index}].files`
                                  );
                                }}
                                allowMultiple
                                name={`other_documents[${index}].files`}
                                labelIdle="Drag & drop files or click to browse"
                              />
                            </div>
                            <ErrorMessage
                              name={`other_documents[${index}].files`}
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-7 col-md-7">
                          <div
                            className="file-pond-main-block d-flex justify-content-left"
                            style={{
                              height: "100%",
                              alignItems: "center",
                              padding: "15px",
                            }}
                          >
                            <div className="row p-0">
                              {doc.existing_files &&
                                doc.existing_files.map((file: any) => (
                                  <>
                                    <div
                                      className="col-md mb-md-0"
                                      style={{
                                        width: "165px",
                                        height: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="form-check custom-option custom-option-icon">
                                        <label
                                          className="form-check-label custom-option-content"
                                          onClick={() =>
                                            window.open(
                                              `${process.env.REACT_APP_BACKEND_URL}${file}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <span className="custom-option-body">
                                            <small>
                                              {getFileNameFromUrl(
                                                `${process.env.REACT_APP_BACKEND_URL}${file}`
                                              )}
                                            </small>
                                          </span>
                                        </label>
                                      </div>
                                      <i
                                        className="fa-solid fa-xmark remove_document_file_btn"
                                        onClick={() => {
                                          doc.remove_files.push(file);
                                          const newFiles =
                                            doc?.existing_files?.filter(
                                              (x: string) => x !== file
                                            );
                                          doc.existing_files = newFiles;
                                          setFieldValue(
                                            `other_documents[${index}]`,
                                            doc
                                          );
                                        }}
                                      ></i>
                                    </div>
                                  </>
                                ))}
                            </div>
                          </div>
                        </div>
                        <i
                          className="fa-solid fa-xmark sales_document_btn"
                          onClick={() => remove(index)}
                        ></i>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            {values.other_documents?.length > 0 && (
              <div className="row m-2 justify-content-end">
                <button
                  title="Add Document"
                  type="button"
                  className="btn btn-primary col-12 col-sm-auto"
                  onClick={() => {
                    push({ document_id: "", files: [] });
                  }}
                >
                  Add Document
                </button>
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};

export default OtherDocumentsFields;
